import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

import type { DiffResult, ItemForOrder } from '../types';
import styles from './styles.module.scss';

interface OwnProps {
	showModal: boolean;
	onClose: () => void;
	onSubmit: () => void;
	diffs: DiffResult<ItemForOrder>;
}

type Props = OwnProps;

interface ItemDiff {
	label: string;
	diffQuantity: number;
}

const OrderItemDiffsModal: React.FC<Props> = (props) => {

	const {
		showModal,
		diffs,
		onClose,
		onSubmit,
	} = props;

	const sortedDiffs = React.useMemo(() => {
		const calculatedDiffs: ItemDiff[] = [];
		calculatedDiffs.push(...diffs.added.map((_itD) => ({ label: `${_itD.itemName} ${_itD.departmentName}`, diffQuantity: -1 * _itD.quantity })));
		calculatedDiffs.push(...diffs.removed.map((_itD) => ({ label: `${_itD.itemName} ${_itD.departmentName}`, diffQuantity: _itD.quantity })));
		calculatedDiffs.push(...diffs.changed.map((_itD) => (
			{ label: `${_itD.before.itemName} ${_itD.before.departmentName}`, diffQuantity: _itD.before.quantity - _itD.after.quantity })
		));
		return calculatedDiffs.sort((a, b) => b.diffQuantity - a.diffQuantity);
	}, [diffs]);

	return (
		<CustomModal
			closeModal={onClose}
			modalStyle="warning"
			showModal={showModal}
			size="md"
		>
			<CustomModal.Header
				closeModal={onClose}
				title={'Item stock changes'}
			/>
			<CustomModal.Body>
				<div>This will have the following changes in the stock:</div>
				<div className={styles.diffsContainer}>
					{sortedDiffs.map((diff) => (
						<React.Fragment key={diff.label}>
							<span className={styles.itemLabel}>{diff.label}</span>
							<span>{diff.diffQuantity > 0 && '+'}{diff.diffQuantity}</span>
						</React.Fragment>
					))}
				</div>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={onClose}
					style="secondary"
				/>
				<Button
					label="Save"
					onClick={onSubmit}
					style="primary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default React.memo(OrderItemDiffsModal);
